module.exports = __webpack_public_path__ + "static/media/status-circle.a9b5e150.svg";